export enum LanguageEnum {
  en_EN = 'en_EN',
  fr_FR = 'fr_FR',
  it_IT = 'it_IT',
  de_DE = 'de_DE',
}

export type Languages = keyof typeof LanguageEnum;
